module.exports = __webpack_public_path__ + "static/index/img/baikal-302.8cbcd315.jpg";